import React from "react";
import { Fade, Grid } from "@material-ui/core";
import TextFieldWrapper, { Selectwrapper } from "../../components/TextField";
import Map from "../../components/Map";

import { connect } from "react-redux";

const RegisterStage3 = ({ register_address }) => {
  return (
    <>
      <Fade in={true} timeout={500}>
        <Grid
          item
          container
          justifyContent="center"
          spacing={2}
          style={{ margin: "auto" }}
        >
          <Grid item xs={12} container justifyContent="center">
            {/* Form section */}

            <Grid item xs={12} container justifyContent="space-between">
              {/* get Info section */}
              <Grid item container xs={6} spacing={1}>
                <SelectContainer>
                  <Grid item xs={6}>
                    <Selectwrapper name="country" label="کشور" readOnly />
                  </Grid>
                  <Grid item xs={6}>
                    <Selectwrapper name="province" label="استان" readOnly />
                  </Grid>
                </SelectContainer>
                <Grid item xs={6}>
                  <Selectwrapper name="city" label="شهر" readOnly />
                </Grid>
                <Grid item xs={6}>
                  <Selectwrapper name="district" label="منطقه" readOnly />
                </Grid>
                <Grid item container xs={12}>
                  <TextFieldWrapper
                    name="address"
                    label="آدرس"
                    multiline
                    rows={4}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item container xs={12}>
                  <TextFieldWrapper name="addressDetails" label="جزئیات آدرس" />
                </Grid>
                <Grid item container xs={12}>
                  <TextFieldWrapper
                    name="pocode"
                    label="کد پستی"
                    type="number"
                  />
                </Grid>
              </Grid>
              {/* map Section     */}
              <Grid item container xs={6}>
                <Map />
              </Grid>
            </Grid>
            {/* <Grid container justifyContent="center" item xs={12}>
            <Link
            style={{
              textDecoration: "none",
              cursor: "pointer",
              margin: "2%",
            }}
            onClick={() => history.push("/")}
            >
            ورود با حساب کاربری
            </Link>
          </Grid> */}
          </Grid>
        </Grid>
      </Fade>
    </>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { register_address } = loginReducer;
  return { register_address };
};

export default connect(mapStateToProps)(RegisterStage3);

const SelectContainer = ({ children }) => {
  return (
    <Grid item xs={12} container spacing={1} style={{ margin: "auto" }}>
      {children}
    </Grid>
  );
};

// const district = [
//   { title: register_address.district, value: register_address.district },
//   { title: register_address.district, value: register_address.district },
// ];

// const province = [{ title: "", value: "" }];
// allCities.map((item) =>
//   province.push({ title: item.name, value: item.name })
// );
// const [provinceValue, setProvinceValue] = React.useState("تهران");
// const cities = [{ title: "", value: "" }];
// const d = allCities.find((item) => item.name === provinceValue);

// d.cities.map((item) => cities.push({ title: item.name, value: item.name }));
